import { getBuildingInsurancesTypes } from '../../../api'
import { getItemsFromApiResponse } from '../../../utils/api'
import { InputAsyncSelect, InputSelectControl } from '../../Select'
import { toBuildingInsuranceTypeSelectItems } from '../Building.utils'

import { BUILDING_INSURANCE_TYPE_SELECT_DROPDOWN_FLOATING_CONFIG } from './BuildingInsuranceTypeSelect.constants'

function BuildingInsuranceTypeSelect({
  Control = InputSelectControl,
  dropdownFloatingConfig = BUILDING_INSURANCE_TYPE_SELECT_DROPDOWN_FLOATING_CONFIG,
  getData = getBuildingInsurancesTypes,
  getDataItems = getItemsFromApiResponse,
  toPreparedItems = toBuildingInsuranceTypeSelectItems,
  ...restProps
}) {
  return (
    <InputAsyncSelect
      {...restProps}
      Control={Control}
      dropdownFloatingConfig={dropdownFloatingConfig}
      getData={getData}
      getDataItems={getDataItems}
      toPreparedItems={toPreparedItems}
    />
  )
}

export default BuildingInsuranceTypeSelect
